import React,{useState,useRef} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../divida.css';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import { te } from 'date-fns/locale';
import { Form, Input, Button } from 'antd';
import { UserOutlined, CreditCardOutlined, IdcardOutlined, EnvironmentOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';

toast.configure()
function Dividas() {
  const [dados, setDados] = useState({ nrscliente: '', nrcliente: "", nome: "", bi: "", nuit: "", morada: "", email: "", telemovel: "" });
  const [apanhado, setApanhado] = useState(null);
  const [error, setError] = useState(null);
  const [remanescente, setRemanescente] = useState(null);
  const [liquidou, setLiquidou] = useState(null);
  const [ant, setAnt] = useState("");
  const [tem, setTem] = useState(null);
  const [temsa, setTemsa] = useState(null);
  const [dad, setDad] = useState({ nrcontador: '', valodivida: '', valorpago: '', remanescente: '', datap: new Date() });
  const [tems, setTems] = useState(null);
  const [paga, setPagaDiv] = useState(null);
  const [m, setm] = useState("");
  const [ad, setAdd] = useState(null);
  const [valordiv, setValordiv] = useState(null);
  const [descricao, setDescricao] = useState(null);
  const reciboPrint = useRef();
  
  const data=[];
    const met=()=>{
      axios({
          method:"post",
          url:`${localStorage.getItem('url')}/web/listacontadores/`,
          headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
          data:{id:dados.nrcliente}
      }).then(dat=>{ if(dat.status!==200){
          throw Error('Dados de acesso invalidos');  
              }
          return dat
       } ).then( d=>{
          console.log(d.data);
          setm(d.data);
          
       }
     
         ).catch(e=>{
          setError(e.message );
      })
  
      
  }
  const DivHandler=e=>{
    e.preventDefault()
    setTem(null);
    setTemsa(null)
    setAdd('sdsd');
  }
  const Adiconar_divida=()=>{
    axios({
      method:"post",
      url:`${localStorage.getItem('url')}/web/AdicionarDivida/`,
      headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
      data:{id:dados.nrcliente,meter:ant,descrica:descricao,divid:valordiv}
  }).then(dat=>{ if(dat.status!==200){
      throw Error('Dados de acesso invalidos');  
          }
      return dat
   } ).then( d=>{
      setAdd(null);
      setRemanescente('sds');
      toast.success('Registrado com Sucesso')
  }
 
     ).catch(e=>{
      setError(e.message );
      toast.error('Erro ao Registrar Dividas!')
  })


  }
    const Pesquisar=()=>{
      axios({
          method:"GET",
          url:`${localStorage.getItem('url')}/web/contador/`,
          headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
          params:{contador:dados.nrcliente}
      }).then(dat=>{ if(dat.status!==200){
          throw Error('Dados de acesso invalidos');  
              }
          return dat
       } ).then( d=>{
        dados.nrscliente=d.data.idcliente;
        dados.nome=d.data.nome;
        dados.nuit=d.data.nuit;
        dados.bi=d.data.bi;
        dados.email=d.data.email;
        dados.morada=d.data.morada;
        dados.telemovel=d.data.telemovel;
        setApanhado("sds");
         }
     
         ).catch(e=>{
          setError(e.message );
          toast.error('Cliente nao encontrado!')
      })
  
  }
  const FDHandler=e=>{
    e.preventDefault()
    Adiconar_divida();
  }
  const dividas=()=>{
    axios({
      method:"post",
      url:`${localStorage.getItem('url')}/web/clieantedividas/`,
      headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
      data:{id:dados.nrscliente,meter:dados.nrcliente}
  }).then(dat=>{ if(dat.status!==200){
      throw Error('Dados de acesso invalidos');  
          }
      return dat
   } ).then( d=>{
     console.log(data)
     data.push(d.data)
     setTem(d.data)
     setTemsa('dfdf');
     dad.valodivida=d.data.divida
     setTems(data.push(d.data))
     console.log(ant)
     console.log(d.data)
      
  }
 
     ).catch(e=>{
      setError(e.message );
      toast.success('Nao possui Divida!')
  })


  }
  const PagarDivida=()=>{
    axios({
      method:"post",
      url:`${localStorage.getItem('url')}/web/pagardivida/`,
      headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
      data:{  id:dados.nrcliente,
        meter:ant,
        valor:paga
      }
  }).then(dat=>{ if(dat.status!==200){
      throw Error('Dados de acesso invalidos');  
          }
      return dat
   } ).then( d=>{
    setTem(null)
    toast.success('Pago com sucesso')
    setLiquidou(d.data);
    
  }
 
     ).catch(e=>{
      setError(e.message );
      toast.error('Cliente nao encontrado!')
  })

  }
  const PagaHandler=e=>{
    e.preventDefault();
    PagarDivida();
  }
  const VerHandler=e=>{
    e.preventDefault();
    setAdd(null);
    dividas();
  }
  const Handler=e=>{
    e.preventDefault();
    Pesquisar();
    met()
   
}
const SVerifica=(valor)=>{
  valor=parseFloat(valor)
  if (valor<=parseFloat(tem.divida)){
      setPagaDiv(valor)
  }else{
    setPagaDiv(0);
  }
}
const Send=(e)=>{
  e.preventDefault();
}

  return (  <Form>
    <Form.Item name="nrcliente" label="Numero do contador">
        <Input onChange={e => setDados({ ...dados, nrcliente: e.target.value })} value={dados.nrcliente}  suffix={<Button type="primary" htmlType="submit" onClick={Handler}>
            Pesquisar
        </Button>}  />
    </Form.Item>
  
    {apanhado && (
        <div className='informacoes'>
            {/* Your existing information div goes here */}
        </div>
    )}
    {m && (
        <div className='subinfos'>
            <div>
                <div id='pci'>
                    <div>Dividas do Cliente:</div>
                    <Button id="opcao" onClick={VerHandler}>Verificar Divida</Button>
                    <Button id="opcao" onClick={DivHandler}>Registrar Divida</Button>
                </div>
                {/* Your existing sub-information div goes here */}
            </div>
            {ad && (
                <div id='pci'>
                    <div>Digite o valor da divida:</div>
                    <Input type="number" id="ipesquia" name="name" autoComplete='off' onChange={e => setValordiv(e.target.value)} value={valordiv} required />
                    <div>Descricao</div>
                    <Input type="text" id="ipesquia" name="name" autoComplete='off' onChange={e => setDescricao(e.target.value)} value={descricao} required />
                    <Button id="opcao" onClick={FDHandler}>Registrar Divida</Button>
                </div>
            )}
        </div>
    )}
</Form>
  )
}

export default Dividas